import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import { getNodeDataDefinition } from '../elements'
import type { Manager } from '../manager'

export const putNodeInCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.putNode.observe().pipe(
      rxjs.map(({ data: { node, chartId: orgChartId } }) => {
        const cy = manager.getInstance({ chartId: orgChartId })
        if (!cy) {
          return
        }
        cy.add({ data: getNodeDataDefinition(node) })
        manager.resetLayout({ chartId: orgChartId })
      }),
      rxjs.ignoreElements(),
    ),
)
